import { DepartmentMapper } from '../mapper/DepartmentMapper';

export const departmentMapper = new DepartmentMapper();
